import React from "react";
import AudioRecorder from "./AudioRecorder";
import { Printer } from "lucide-react";

const BookView = ({ projectId, photos, onUpdate }) => {
  const acceptedPhotos = photos.filter(p => p.status === 'accepted');

  if (acceptedPhotos.length === 0) {
    return (
        <div className="text-center py-20 text-slate-500">
            No photos selected yet. Go to Curator mode to pick some!
        </div>
    );
  }

  return (
    <div>
        <div className="flex justify-end mb-4 no-print">
            <button 
                onClick={() => window.print()}
                className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition-colors"
            >
                <Printer className="w-4 h-4" /> Print Book / Save PDF
            </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 print:grid-cols-1 print:gap-12">
        {acceptedPhotos.map((photo, index) => (
            <div key={photo.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col print:shadow-none print:border-none print:break-inside-avoid">
                <div className="aspect-[4/3] bg-slate-100 relative group">
                    <img
                        src={`${process.env.REACT_APP_BACKEND_URL}${photo.url}`}
                        alt={photo.filename}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="p-4 border-t border-slate-100 flex-1 flex flex-col justify-between print:border-none">
                    <div>
                        <div className="text-xs text-slate-400 mb-2 uppercase tracking-wider font-bold">Page {index + 1}</div>
                        <p className="text-sm text-slate-700 italic min-h-[1.5rem] mb-3">
                            {photo.caption || "No caption..."}
                        </p>
                    </div>
                    
                    <div className="border-t border-slate-100 pt-3 no-print">
                        <AudioRecorder 
                            projectId={projectId} 
                            photoId={photo.id} 
                            existingAudio={photo.audio_url}
                            onUploadComplete={() => onUpdate()}
                        />
                    </div>
                    {/* QR Code Placeholder for Print */}
                    {photo.audio_url && (
                        <div className="hidden print:block mt-4 pt-4 border-t border-slate-200">
                             <div className="flex items-center gap-4">
                                <div className="w-16 h-16 bg-slate-900 text-white text-xs flex items-center justify-center text-center p-1">
                                    [QR Code Placeholder]
                                </div>
                                <div className="text-xs text-slate-500">
                                    Scan to hear family story
                                </div>
                             </div>
                        </div>
                    )}
                </div>
            </div>
        ))}
        </div>
    </div>
  );
};

export default BookView;
